import Nav from "./nav"
import Search from "./search"
import Form from "./form"
import Slider from "./slider"
import Tabs from "./tabs"
import Dropdown from "./dropdown"


document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
    Slider(jQuery)
    Tabs(jQuery)
    Dropdown(jQuery)
})
